import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React, { useCallback, useRef, useState } from 'react';
import classnames from 'classnames';
import { getSrcSet } from '../../../DeviationViews/Dumbo/Image/_helpers';
import ZoomModal from './ZoomModal';
import SeoData from '../../Dumbo/_partials/SeoData';
import { scaleToSize } from '../../_helpers';
import { useFullview } from './hooks/useFullview';
import IconButton from '@wix/da-ds/pkg/Buttons/IconButton';
import AddVideoIcon from '@wix/da-ds/pkg/Icons/24x24/AddVideo';
import numeral from 'numeral';
import { yieldToMain } from '@wix/da-hooks/pkg/yieldToMain';
import s from './ImageFullview.scss';
export const ImageFullView = ({ width, height, deviation, isZoomed, onEnterZoomMode, onExitZoomMode })=>{
    const imgRef = useRef(null);
    const [playButtonShown, setPlayButtonShown] = useState(true);
    const { previewFile, srcFile, isFullscreen, isPixel, canZoom, src, srcSet, sizes, isLargeGif } = useFullview({
        stageWidth: width !== null && width !== void 0 ? width : 0,
        stageHeight: height !== null && height !== void 0 ? height : 0,
        deviation
    });
    const handleClick = useCallback((e)=>{
        if (isLargeGif && imgRef.current && playButtonShown) {
            imgRef.current.srcset = ''; // force the src to show
            setPlayButtonShown(false);
            return;
        }
        if (canZoom && onEnterZoomMode) {
            // This is for INP purposes
            if (imgRef.current) {
                imgRef.current.style.opacity = '0.8';
            }
            yieldToMain(()=>{
                onEnterZoomMode();
            });
        }
    }, [
        canZoom,
        isLargeGif,
        onEnterZoomMode,
        playButtonShown
    ]);
    const handleCloseZoom = useCallback(()=>{
        if (imgRef.current) {
            imgRef.current.style.opacity = '1';
        }
        onExitZoomMode && onExitZoomMode();
    }, [
        onExitZoomMode
    ]);
    if (!previewFile || !srcFile) {
        return null;
    }
    const size = scaleToSize(previewFile, {
        width,
        height
    });
    const wrapperSeoProps = {
        typeof: 'ImageObject',
        vocab: 'https://schema.org/'
    };
    const imgExtraProps = {
        property: 'contentUrl',
        fetchPriority: 'high'
    };
    var _deviation_title;
    return /*#__PURE__*/ React.createElement("div", _object_spread({
        className: classnames(s['root'], isFullscreen && s['fullscreen']),
        style: {
            width,
            height
        }
    }, wrapperSeoProps), isZoomed && srcFile && /*#__PURE__*/ React.createElement(ZoomModal, {
        src: srcFile.src,
        srcSet: getSrcSet(deviation),
        width: srcFile.width,
        height: srcFile.height,
        isPixel: !!isPixel,
        onClose: handleCloseZoom
    }), isLargeGif && playButtonShown && /*#__PURE__*/ React.createElement("div", {
        className: s['gif-player'],
        style: size
    }, /*#__PURE__*/ React.createElement(IconButton, {
        icon: AddVideoIcon,
        size: 'large',
        onClick: handleClick
    }, "Play Gif"), /*#__PURE__*/ React.createElement("div", null, "Play large GIF (", numeral(srcFile.filesize).format('0.00b'), ")")), /*#__PURE__*/ React.createElement("img", _object_spread({
        key: `fv-${deviation.deviationId}`,
        ref: imgRef,
        alt: (_deviation_title = deviation.title) !== null && _deviation_title !== void 0 ? _deviation_title : '',
        "aria-hidden": "true",
        className: classnames(s['image'], isPixel && s['pixel'], canZoom && s['zoomable']),
        src: src,
        srcSet: srcSet,
        sizes: sizes,
        style: size,
        onClick: handleClick
    }, imgExtraProps)), /*#__PURE__*/ React.createElement(SeoData, {
        deviation: deviation
    }));
};
ImageFullView.displayName = 'ImageFullView';
export default ImageFullView;
